<template>
  <div class="breadcrumb">
    <nav class="breadcrumb" property="breadcrumb" aria-label="breadcrumb">
      <ul>
        <li
          v-for="(breadcrumb, idx) in breadcrumbList"
          :key="idx"
          @click="routeTo(idx)"
          :class="{ linked: !!breadcrumb.link }"
        >
          <a v-if="$i18n.locale == 'en'">{{ breadcrumb.name }}</a>
          <a v-if="$i18n.locale == 'fr'">{{ breadcrumb.nameFr }}</a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Breadcrumb",
  data() {
    return {
      breadcrumbList: []
    };
  },
  mounted() {
    this.updateList();
  },
  watch: {
    $route() {
      this.updateList();
    }
  },
  methods: {
    routeTo(pRouteTo) {
      if (this.breadcrumbList[pRouteTo].link)
        this.$router.push(this.breadcrumbList[pRouteTo].link);
    },
    updateList() {
      this.breadcrumbList = this.$route.meta.breadcrumb;
    }
  }
};
</script>
<style></style>
